<i
  class="app__icon {{ color }}"
  [class.nc__icon__checkbox__selected]="selected"
  [class.nc__icon__checkbox__unselected]="!selected"
  [class.disabled]="disabled"
>
</i>
